/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
// material
import { styled } from '@mui/material/styles';
import { Toolbar, Typography } from '@mui/material';
import { DatePicker } from 'antd';

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

// ----------------------------------------------------------------------

PaymentListToolbar.propTypes = {
  numSelected: PropTypes.number,
  setDates: PropTypes.func,
};

const { RangePicker } = DatePicker;

export default function PaymentListToolbar({ numSelected, setDates }) {
  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 && (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      )}
      <RangePicker onChange={(dates, dateStrings) => setDates(dateStrings)} />
    </RootStyle>
  );
}
